const AMLBOT_WEB_URL = import.meta.env.VITE_REACT_APP_AMLBOT_WEB_URL!;

export const APP_SOURCE = "amlbot-widget";
export const DEFAULT_PAYMENT_CURRENCY = "USD";
export const WIDGET_WIDTH = 430;
export const WIDGET_HEIGHT = 600;
export const TELEGRAM_SUPPORT_BOT_URL = "https://t.me/amlbot_support_bot";
export const AMLBOT_WEB_HREF = AMLBOT_WEB_URL;
export const MODE_INLINE = "inline";
export const MODE_FLOAT = "float";
export const ALLOWED_WIDGET_MODES = [MODE_INLINE, MODE_FLOAT];
export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";
